import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateService } from 'angular-ui-router';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMonoOccurrence } from '../../../../../core/services/mono-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';

interface IPageDo0069 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    monoOccurrence: IMonoOccurrence,
}

/* @ngInject */
export default function Do0069Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    Menu: IMenuClass,
    do0064Route: IRoute,
    rr0074Route: IRoute,
    rr0075Route: IRoute,
    rr0006Route: IRoute,
    $state: IStateService,
    MenuItemEcran: IMenuItemEcranClass
) {
    const vm: IPageDo0069 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            reinitialiserOuvrirCriteres: true,
            selectionCycle: false,
            criteresSuggeresVisibles:true
        },
         actionsRangeeDroite: new Menu([
            new MenuItemForage(
                'LBL_INFO_FINANC',
                (rowData: any) => getForageItem(rowData),
                (rowData: any) => getParamItem(rowData),
                {
                    icon: 'exit_to_app',
                    fonction: 'BOUOUV',
                }
            )
        ]),
        criteresSuggeres: new Formulaire([
            new FormulaireItem('eplnomprn', {readonly: true, default: ecranDetails.valeurs.eplnomprn,
                largeur: 33, ignoreEtat: true
            }),
            new FormulaireItem('t_ofadatdeb', {default: $state.params.ofadatdeb, readonly:true,
                largeur: 33, ignoreEtat: true
            }),
            new FormulaireItem('t_ofadatfin', {default: $state.params.ofadatfin, readonly:true,
                largeur: 33, ignoreEtat: true
            }),
            new FormulaireItem('t_trmcleint', {
                largeur: 33
            }),
            new FormulaireItem('t_datde', {default: $state.params.ofadatdeb,
                largeur: 33
            }),
            new FormulaireItem('t_data', {default: $state.params.ofadatfin,
                largeur: 33
            }),            
        ]),
        colonnesVisibles: [
            { nom: 'typdsc', largeur: 155},
            { nom: 'numdoc', largeur: 130},
            { nom: 'dsc', largeur: 160},
            { nom: 'datdeb', largeur: 110},
            { nom: 'datfin', largeur: 110},
            { nom: 'qte', largeur: 130 },
            { nom: 'qtesem', largeur: 130},
            { nom: 'nbrsemori', largeur: 125 },
            { nom: 'nbrsem', largeur: 130},
            { nom: 'qteft', largeur: 130},
            { nom: 't_qtetot', largeur: 130, total: true},
            { nom: 'unocod', largeur: 125},
            { nom: 'unodsc', largeur: 220}
        ],
        colonnesCachees: ['trncleint', 'ecrcod'],
        
    }

    function getForageItem(rowData: any): string {
    if (rowData.ecrcod === 'RR0006-00-2') {
        return rr0006Route.NAME;
    } else if (rowData.ecrcod === 'RR0074-00-2') {
        return rr0074Route.NAME;       
    } else if (rowData.ecrcod === 'RR0075-00-2') {
        return rr0075Route.NAME;
    } else if (rowData.ecrcod === 'DO0064-00-2') {
        return do0064Route.NAME;
    } 
    return do0064Route.NAME;
}
function getParamItem(rowData: any) {
    if (rowData.ecrcod === 'RR0006-00-2') {
        return { id: rowData.trncleint };        
    } else if  (rowData.ecrcod === 'RR0074-00-2') {
        return { id: rowData.trncleint};
    } else if (rowData.ecrcod === 'RR0075-00-2') {
        return { id: rowData.trncleint};        
    } else if (rowData.ecrcod === 'DO0064-00-2') {
        return { id: rowData.sysaffcleint};        
    }
    return { id: rowData.sysaffcleint || rowData.trncleint };
}
}
